/**
 * Controller: SettingsTerminalsCreateModal
 */
angular.module('acme.view.application.settings.terminals.createModal.controllers', [
  'ui.bootstrap',
  'acme.common.service.terminals',
  'acme.common.factory.notice'
])
.controller('SettingsTerminalsCreateModalController', [ '$scope', '$uibModalInstance', 'terminals', 'config', 'TerminalsService', 'NoticeFactory', function ($scope, $uibModalInstance, terminals, config, TerminalsService, NoticeFactory) {

    $scope.notice = new NoticeFactory();

    $scope.model = {
      terminalId: '',
      name: '',
      description: '',
      type: 'pos',
      amount: '0',
      configId: null
    };

    $scope.types = TerminalsService.types;
    
    $scope.config = [];

    $scope.init = function() {
      $scope.config = config.data.payload.list;
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isType = function(type) {
      return ($scope.model.type.toLowerCase() === type.toLowerCase());
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.terminalId),
        r = true;

      for (i=0,ii=terminals.length;i<ii;i++) {
        trimmed = $scope.trim(terminals[i].terminalId);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      var amount = parseInt($scope.model.amount, 10);
      
      if ($scope.isUnique()) {
        if ($scope.model.terminalId.replace(/\s+/g, '').length > 0) {
          if (!isNaN(amount) && amount >= 0) {
            $scope.success();
          }else{
            $scope.notice.showErrorMessages([{ message: 'Please enter a valid cash amount'}]);
          }
        }else{
          $scope.notice.showErrorMessages([{ message: 'Please enter a valid terminal id'}]);
        }
      }else{
        $scope.notice.showErrorMessages([{ message: 'A terminal with id "' + $scope.model.terminalId + '" already exists' }]);
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);